<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
      
        <!--  <b-breadcrumb :items="breadcrumbs"/>   -->
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Expense Entry </strong>
          </div>
          <b-row class="">

            <div id="overlayloder" v-if="lodershow">
              <div class="loader_loder"></div>
            </div>

            <b-col md="12" class="my-1">
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="HUB Name ">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="hub_name" v-model="hub_name" disabled>
                            </b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="5">

                  </b-col>

                  <b-col cols="3">
                    <b-form-group label="Total COD Amount in Hub ">
                        <b-input-group :label-cols="4">                     
                            <b-form-input class="input" type="text" name="Total COD Amount in Hub" v-model="totalCodAmountInHub" disabled >
                            </b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>


                <b-row>
                 <form style="width:100%">
                    <div class="table-responsive">
                    <table class="table table-striped " >
                    <thead>
                        <tr> 
                        <th scope="col">Date</th>
                        <th scope="col">Expense Reason</th>
                        <th scope="col">Expense Amount</th>
                        <th scope="col">Upload Document</th>
                        <th scope="col">Download Document</th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                       
                        <tr v-for="(expense, index) in expenses" :key="index">
                        
                        <td>
                            <b-input-group>
                            <!-- <b-form-input
                                class="input"
                                input-class="dateInput"
                                type="date"                                                                      
                                v-model="expense.expense_date" required
                            ></b-form-input> -->
                            <v-date-picker
                              mode="single"
                              input-class="dateInput"
                              :available-dates="{ start: null, end: new Date() }"
                              v-model="expense.expense_date" required
                            ></v-date-picker>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group>
                            <b-form-input
                                class="input"
                                type="text"
                                v-model="expense.expense_reason" required
                            ></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group>
                            <b-form-input
                                class="input"
                                type="number"                               
                                v-model = "expense.expense_amount"
                                required
                            ></b-form-input>
                            </b-input-group>
                        </td>
                        <td>    
                            <b-form-file
                            v-model="upload_document"
                            :state="Boolean(file)"
                            @change="selectFile($event,index)"
                            required
                            :class="{
                                input: true,
                                'text-danger': errors.has('form-1.file'),
                            }"
                            ></b-form-file>
                   
                        </td>
                        <td>
                            
                            <a :href="expense.uploaded_document" target="_blank">
                              <b-button size="md" class="m-1" variant="primary">
                                <i class="fa fa-download"></i>
                              </b-button></a>
                            
                        </td>
                         <td>
                            <b-button size="sm" class="m-2" @click="removeExpense(index)">
                            <i class="fa fa-times "></i>
                            </b-button>
                        </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                        <td colspan="6">
                            <b-button size="md" class="m-1" variant="success" @click="addExpense"
                            >Add More Expense</b-button
                            >
                        </td>
                        </tr>
                        
                    </tfoot>
                    </table>
                    <b-button class="pl-5 pr-5" size="md" variant="success" @click="displaydata()"
                      >Send to Finance
                    </b-button>
                    <!-- <b-button v-if="isUpdateBtn" class="pl-5 pr-5 ml-3" size="md" variant="primary" 
                      >Update
                    </b-button> -->
                    </div>
                 
                    

                    </form>
                 
                </b-row>


                  <hr>
              <b-row class="mt-5">
                 <b-col cols="4">
                    <b-form-group label="From Date : "  :label-cols="3" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                        :available-dates="{ start: null, end: new Date() }"
                        v-model="fromDate"
                      >
                      </v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="To Date : "  :label-cols="3" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                        :available-dates="{ start: null, end: new Date() }"
                        v-model="toDate"
                      >
                      </v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="text-align:left;">
                    <b-form-group>
                      <button class="btn btn-primary" @click="searchExpenselist()"> Search
                        </button>
                        <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i>
                        </button>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="text-align:right;" v-if="isDownloadBtn == true">
                    <b-form-group>
                      <button class="btn btn-primary" @click="expenseLogCSV">Download
                        </button>
                    </b-form-group>
                  </b-col>
             </b-row>

            

                <b-row>
                    <b-table
                      responsive
                      class="tableOFD"
                      show-empty
                      stacked="md"
                      :items="expensedata"
                      :fields="fields"
                      :bordered="bordered"
                      thead-class="Collected"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      @filtered="onFiltered"
                      :busy="isBusy1"
            
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>

                       <!-- <template slot="pendingapproval" slot-scope="row">
                        <p v-if="row.item.status == 'Pending'" style="text-align: center; color:green"><i class="fa fa-check"></i></p>
                      </template>

                      <template slot="approval" slot-scope="row">
                        <p v-if="row.item.status == 'Approve'" style="text-align: center; color:green"><i class="fa fa-check"></i></p>
                      </template>

                      <template slot="reject" slot-scope="row">
                        <p v-if="row.item.status == 'Reject'" style="text-align: center; color:green"><i class="fa fa-check"></i></p>
                      </template> -->

                      <template slot="Srno" slot-scope="row" v-for="(expense, index) in expensedata">
                        <p>{{ ((pageNo-1) * perPage) + row.index + 1}}</p>
                      </template>

                      <template slot="downloaddoc" slot-scope="row" >
                        <p v-if="row.item.uploaded_document != '' " 
                            style="text-align: center; color:green"><a :href="row.item.uploaded_document" download>
                            <i class="fa fa-download"></i>
                            </a></p>
                      </template>


                      <template slot="download" slot-scope="row">
                        <button class="btn btn-primary">
                          <i class="fa fa-download"></i>
                        </button>
                      </template>

                      <!-- <template slot="editExpense" slot-scope="row">
                        <div v-if="row.item.status=='Rejected'">
                          <button class="btn btn-primary ml-2" @click="editExpenseDetails(row)">
                            Edit
                          </button>
                        </div>
                      </template> -->

                      <template slot="finance_query" slot-scope="row">
                        <p v-if="row.item.status == 'Rejected'" >{{ row.item.finance_query }}</p>
                      </template> 

                      <template slot="editExpense" slot-scope="row">
                        <b-button
                          v-if="row.item.status==='Rejected'"
                          @click="row.toggleDetails();editExpenseClosure(row,row.detailsShowing);"
                          class="btn btn-primary ml-2"
                          style="background: #b0c4de !important;color: #000 !important;"
                        >
                          {{ row.detailsShowing ? "Hide" : "Edit" }} Expense
                        </b-button>
                      </template>

                      <template slot="row-details" slot-scope="row">
                        <b-card title="Edit Expense">
                          <form @submit.prevent="updateExpenseClosure(row)">
                            <b-row>
                              <b-col cols="4">
                                <b-form-group label="Expense Reason">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="text" name="Expense Reason" v-model="editExpense_reason" v-validate="'required'">
                                    </b-form-input>                                        
                                  </b-input-group>                                    
                                </b-form-group>
                              </b-col>

                              <b-col cols="4">
                                <b-form-group label="Expense Amount">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="number" name="Expense Amount" v-model="editExpense_amount" v-validate="'required'">
                                    </b-form-input>                                    
                                  </b-input-group>                               
                                </b-form-group>
                              </b-col>

                              <b-col cols="4">
                                <b-form-group label="Upload Document">
                                  <b-form-file
                                    v-model="editUpload_document"
                                    :state="Boolean(file)"
                                    @change="selectFile($event)"                                        
                                  ></b-form-file>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col cols="4 mt-3">
                                <b-button size="md" variant="primary" type="submit">Update</b-button>
                              </b-col>
                            </b-row>

                            <b-col sm="12">
                              <div slot="footer" class="text-right">
                                <b-button
                                  size="sm"
                                  @click="row.toggleDetails"
                                  variant="danger"
                                  style="background: #b0c4de !important;color: #000 !important;"
                                  >Cancle</b-button
                                >
                              </div>
                            </b-col>
                          </form>
                        </b-card>
                      </template>

                    </b-table>
                </b-row>
            </b-col>

            <b-col md="12" class="my-1 ">
            <!-- <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination> -->
            <paginate
                
                v-model="pageNo"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :current-page="currentPage"
              >
              </paginate>
          </b-col>  
            
          </b-row>
        
        </b-card>
      </b-col> 
      
      </b-row>

  </div>
</template>




<script>
import CONSTANTS from "@/utils/constants";
import Filters from "@/utils/filters";
import Utils from "@/utils";
export default {
  data: function() {
    return {
     codCollectionDate: '',
     fields: [
        {  
          key: "Srno",
          label: "Sr.No",
        },
        {
          key: "expense_date",
          label: "Date Of Expense",
        },
        {
          key: "created_date",
          label: "Created Date",
        },
        {
          key: "expense_amount",
          label: "Amount",
        },
        // {
        //   key: "pendingapproval",
        //   label: "Pending Approval",
        // },
        // {
        //   key: "approval",
        //   label: "Approve",
        // },
        // {
        //   key: "reject",
        //   label: "Reject",
        // },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "downloaddoc",
          label: "Download Document",
        },
        {
          key: "finance_query",
          label: "Finance Query",
        },

        { key: "editExpense", label: "Action" },
      ],

       expenses: [{ expense_date: new Date(), expense_reason: "", expense_amount: "", uploaded_document: ""}], // Initial expense row
       hub_name:'',
       expensedata:[],
       selectedFiles:'',
       upload_document:'',
       sampleImageurl:[],
       
       perPage: 10,
        currentPage: 1,
        pageNo: 1,
        noofpages: 0,
        toDate:new Date(),
        fromDate:new Date(),
        page: "",
        downloadcsv:'',
        isDownloadBtn: true,
        isUpdateBtn: false,

        //for edit expense
        editExpense_reason:'',
        editExpense_amount:0,
        editUpload_document:'',

        totalCodAmountInHub:0,
    }
  },


   created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hub_name = userInfo.pickuplocationname
    this.getTotalCodAmountInHub();
  
  },

  
    mounted() {
        this.getcodCollectionDate();
        this.codExpenselist(this.pageNo)
  
    },



    methods: {
        
    addExpense() {
      this.expenses.push({ expense_date: new Date(), expense_reason: "", expense_amount: "", uploaded_document: "" });
    },

    removeExpense(index) {
      this.expenses.splice(index, 1);
    },

    handleExpenseAmount(value,expenseObj,index){
      var newValue = parseFloat(value)
      console.log("Expense Amount entered-->",newValue,typeof(newValue));
      if(newValue <= 0 || newValue===undefined){
        // this.$fire({
        //   text:"Expense should be greater than 0",
        //   type: "warning",
        //   timer: 30000
        // });
        this.expenses[index].expense_amount = ""; 
      }
      else{
        this.expenses[index].expense_amount = newValue;
      }
    },

    displaydata(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      let isOk = true

      for (let i = 0; i < this.expenses.length; i++) {
        if(this.expenses[i].expense_date == '' || this.expenses[i].expense_amount == '' || this.expenses[i].expense_reason == '' || this.upload_document == '')
        {
          isOk = false;
                // this.updateExpenseWithUrls();
          this.$fire({
            text:"Please select all the fields for expense",
            type: "error",
            timer: 1000000
          }); 
        }

        else if(this.expenses[i].expense_amount <= 0){
          isOk = false;
          this.$fire({
            text:"Expense Amount Should be greater than 0 for "+ this.expenses[i].expense_reason,
            type: "error",
            timer: 1000000
          }); 
        }
        // if((i == this.expenses.length-1) && isOk){
        //     this.updateExpenseWithUrls();
        // }
      }
      if(isOk){
            this.updateExpenseWithUrls();
        }
      
    },

    clickCallback(pageNo){
          this.codExpenselist(pageNo)
    },

    updateExpenseWithUrls(){
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        // console.log("Expense Data:", this.expenses);
        // console.log(" this.sampleImageurl:",  this.sampleImageurl);
        this.sampleImageurl.forEach((url, index) => {
            if (this.expenses[index]) {
            this.expenses[index].uploaded_document = url;
            }
        });
            
        // var totalExpense = 0;

        // this.expenses.forEach((expense,index) =>{
        //     this.expenses[index].expense_date=this.formatDate(expense.expense_date);
        //     totalExpense += parseFloat(this.expenses[index].expense_amount)
        // });
        // console.log("Total Expense--->",totalExpense.toFixed(2));
        // console.log("Expense Added--->",this.expenses);

        // if(totalExpense > this.totalCodAmountInHub){
        //   this.$fire({
        //     text:"Total Expense Amount Exceeds total COD Amount in Hub!!!",
        //     type: "warning",
        //     timer: 30000
        //   })
        //   document.getElementById("overlay").style.display = "none";
        //   return
        // }
 
        const obj = {
            expenses: this.expenses,
            hub_id: userInfo.pickuplocationmasterid,      
            created_by: userInfo.sysemailid,
            //totalExpense: totalExpense
        }

        // // Set to store unique objects
        // const uniqueObjects = new Set();

        // // Convert object to a string and add to set
        // uniqueObjects.add(JSON.stringify(obj));

        // // Convert back to JSON and log
        // console.log(JSON.parse([...uniqueObjects][0]));

        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/submitExpenses`,obj)
          .then(result => {
            document.getElementById("overlay").style.display = "none";
            if(result.body.returnmsg=='Successful'){
                 this.$fire({
                  text:"Expenses added successfully",
                  type: "success",
                  timer: 30000
                }); 
             this.expenses = [];
             this.getTotalCodAmountInHub();
             this.codExpenselist(this.pageNo)
            }
            else{

             this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
                document.getElementById("overlay").style.display = "none";

            }

               
            })
            .catch(ex => {
                console.log('error', ex)
                this.$fire({
                  text:"Unable to submit Expense!!!",
                  type: "warning",
                  timer: 30000
                }); s
                document.getElementById("overlay").style.display = "none";
            });

    },
 
    selectFile(event,index){
 
    console.log(this.selectedFiles[index])
    document.getElementById("overlay").style.display = "block";
      this.selectedFiles = event.target.files[0];
      

         let data = new FormData();
          let config = {
              header : {
               'Content-Type' : 'multipart/form-data'
             }
            }
            data.append('file', this.selectedFiles)
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/uploadImageToS3`,data, {header : {
           'Content-Type' : 'multipart/form-data'
         },
         })
          .then(Response => {
            document.getElementById("overlay").style.display = "none";
             if(Response.data.result === 'success'){
              
                this.sampleImageurl.push(Response.data.image_url);
                this.editUpload_document = Response.data.image_url
                this.expenses[index].uploaded_document = Response.data.image_url;
                
                
                console.log("expenses-->",this.expenses);
            } else {
                // alert("something went wrong")
                this.sampleImageurl=[];
            }
            })

    //   var imgname = this.selectedFiles.name;
    //   console.log(this.selectedFiles);
    //   console.log("imgnameimgnameimgname", imgname)
    },

    codExpenselist(pageNo){
        // alert(pageNo)
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        var hubobj={
          hub_id:currenthub.toString(),
          from_date: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          to_date: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: pageNo ? pageNo : 1,
        //   limit: 10
        }
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/expenseLogListing`,hubobj)
          .then(result => {
            
            if(result.body.returnmsg=='Successful'){
            this.expensedata = result.body.returnvalue;
             this.noofpages = result.body.total_count / 10
            }

            //console.log('mukesh',this.hublist);
          })
          .catch(ex => {
            console.log('error', ex)
          });
    },



    searchExpenselist(){
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

         if(this.fromDate > this.toDate)
        {
             this.$fire({
                  text: "From date must be greater than To date",
                  type: "warning",
                  timer: 30000
                }); 
        }
        else{
        var hubobj={
          hub_id:currenthub.toString(),
          from_date: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          to_date: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: this.pageNo ? this.pageNo : 1,
        //   limit: 10
        }
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/expenseLogListing`,hubobj)
          .then(result => {
            document.getElementById("overlay").style.display = "none";
            if(result.body.returnmsg=='Successful'){
            this.isDownloadBtn = true;
            this.expensedata = result.body.returnvalue;
             this.noofpages = result.body.total_count / 10
            }
            else{

                this.isDownloadBtn = false;
                 this.expensedata = []
            }

            //console.log('mukesh',this.hublist);
          })
          .catch(ex => {
            console.log('error', ex)
          });

        }
    },


    expenseLogCSV(){
        document.getElementById("overlay").style.display = "block";
        // alert(this.codCollectionDate)
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        var hubobj={
          hub_id:currenthub.toString(),
          from_date: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          to_date: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: this.pageNo ? this.pageNo : 1,
          limit: 10
        }
          this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/expenseLogCSV`,hubobj)
         .then(Response => {

            document.getElementById("overlay").style.display = "none";
             if(Response.body){
                console.log(Response)
                this.downloadCSV(Response.body)
            } else {
               console.log("in else")
                this.downloadcsv='';
            }
            })

     },

    downloadCSV(data) {    
        const csvData = data
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'COD_expenses.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    },
    
    editExpenseClosure(row,showhide){
      console.log('Expense row for edit--->',row.item);
      var showhides=showhide;

      if(showhides)
      {

      }
      else{
        this.editExpense_reason = row.item.expense_reason,
        this.editExpense_amount = row.item.expense_amount,
        this.editUpload_document = row.item.uploaded_document
      }
    },

    updateExpenseClosure(row){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var currentUser=userInfo.sysemailid;

      if(this.editExpense_amount <= 0){
        this.$fire({
          text:"Expense Amount should be greater than 0",
          type: "warning",
          timer: 30000
        }); 
      }

      else{  
        const Obj={
          id : row.item.id,
          hub_id: userInfo.pickuplocationmasterid, 
          expense_amount : this.editExpense_amount ? this.editExpense_amount : null,
          expense_reason : this.editExpense_reason ? this.editExpense_reason : null,
          uploaded_document : this.editUpload_document ? this.editUpload_document : null,
          updated_by : currentUser
        }

        console.log("Edit Obj--->",Obj)

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/editRejectedRequestinHubAdmin`, Obj)
        .then(result => {
          if(result.body.returnmsg==='Successful'){
            this.$fire({
              text: "request updated successfully",
              type: "success",
              timer: 30000
            });
            this.getTotalCodAmountInHub();
            this.codExpenselist(1);       
          } 
          else{
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000
            }); 
          }
        })
        .catch(ex => {
          console.log('error', ex)
          this.$fire({
            text:"Unable to Edit Expense!!!",
            type: "warning",
            timer: 30000
          }); 
        });
      }
    },

    refresh(){
        this.fromDate = new Date();
        this.toDate = new Date();
        this.pageNo = 1;
        this.codExpenselist(this.pageNo);
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },


     getcodCollectionDate() {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();

      // Adding leading zero for single-digit month and day
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      this.codCollectionDate = `${year}-${month}-${day}`;
    },

    getTotalCodAmountInHub(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      console.log("userInfo",userInfo)
      var currenthub=userInfo.pickuplocationmasterid;

      var hubobj={
        hub_id:currenthub.toString()
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTotalCODAmountInHUB`,hubobj)
      .then(result => {
  
        if(result.body.returnmsg=='Successful'){         
          this.totalCodAmountInHub = result.body.returnvalue[0].total_cod_amount_in_hub;       
        }
        else{
          this.totalCodAmountInHub = 0;
          this.$fire({
            text: "Error While Fetching Total COD Amount in Hub!!! ",
            type: "warning",
            timer: 30000
          }); 
        }
           
      })
      .catch(ex => {
        console.log('error', ex)
      });
    }

    }


}

</script>


<style type="text/css">
.totalback {
  background: #c8ced3 !important;
  border-right: 1px solid grey !important;
}

.Collected {
  text-align: center !important;
}
#overlayloder {
  position: fixed; /* Sit on top of the page content */
  /*display: none;  Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loader_loder  {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.bordered-value{

  padding:15px;
  border-bottom:1px solid #C8CED3;
  margin:-9px;
}

.hidden_header {
  display: none;
}

th{
  text-align:center;
}

.table-striped__immediate-only > tbody > tr:nth-of-type(odd) {
        background-color: rgba(0,0,0,.05);
}


</style>
